import moment from 'moment';

export const getPolicyDate = (value: Date | string | null) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return moment(value).format('MMMM D, YYYY');
  }

  const isValid = moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true).isValid();

  if (!isValid) {
    return value;
  }

  return moment(value).format('MMMM D, YYYY');
};
